import React, { useEffect, useState } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import '../ReportStyle.css';
import moment from 'moment';
import * as XLSX from 'xlsx';
import ExportButtons from '../ExportButtons';
import { formatCurrency } from '../../../../../../helpers/pcontas';

const DirdFinancialBalance = (props) => {
    const [items, setItems] = useState([]);

    const startDate = moment(props.filters.startDate).format('DD/MM/YYYY');
    const endDate = moment(props.filters.endDate).format('DD/MM/YYYY');

    useEffect(() => {
        const fetchData = async () => {
            const response = await Fetch.post(
                config.endpoints.backend + 'portal/getreport',
                props.filters
            );
            setItems(response);
        };

        fetchData();
    }, [props.filters]);

    function dataForSheet() {
        let sheets = {};
        const sourceFincancialBalanceTable = document.getElementById(
            'sourceFinancialBalanceReport'
        );
        const sourceFincancialBalanceData = XLSX.utils.sheet_to_json(
            XLSX.utils.table_to_sheet(sourceFincancialBalanceTable, {
                raw: true
            }),
            { raw: true, header: 1 }
        );

        sheets.sourceFincancialBalanceData = sourceFincancialBalanceData;

        return sheets;
    }

    function dataForCsv() {
        const tableSourceFinancialBalance = document.getElementById(
            'sourceFinancialBalanceReport'
        );

        const dataTableSourceFinancialBalance = XLSX.utils.sheet_to_json(
            XLSX.utils.table_to_sheet(tableSourceFinancialBalance, {
                raw: true
            }),
            { header: 1, raw: true }
        );

        let combinedData = [];

        combinedData = combinedData.concat(dataTableSourceFinancialBalance);

        return combinedData;
    }

    function dataForJson() {
        let dirdFinancialBalance = {};

        items.reports.data.sourcesFinancialBalances.forEach((item) => {
            dirdFinancialBalance[item.description] = item.value;
        });

        return {
            dirdFinancialBalance
        };
    }

    return (
        <div>
            {items.reports && (
                <div className="containerDird">
                    <div className="row info-filters">
                        <div className="col-12">
                            <p>
                                Projeto:{' '}
                                <b>{items.reports.pdcProject.project_name}</b>
                            </p>
                        </div>
                        <div className="col-12">
                            <p>
                                Origem dos Recursos:{' '}
                                <b>{items.reports.originResourceName}</b>
                            </p>
                        </div>
                        <div className="col-12">
                            <p>
                                Período Selecionado:{' '}
                                <b>
                                    {startDate} até {endDate}
                                </b>
                            </p>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <ExportButtons
                            jsonData={dataForJson}
                            csvData={dataForCsv}
                            sheetData={dataForSheet}
                            pdfAttributes={{
                                ids: ['sourceFinancialBalanceReport']
                            }}
                            txtAttributes={{
                                sourceFinancialBalanceReport: {
                                    colSizes: [80]
                                }
                            }}
                        />
                    </div>
                    <div className="row">
                        <table
                            className="table tables-report"
                            id="sourceFinancialBalanceReport"
                            margin="2"
                            cellspacing="0"
                            cellpadding="5"
                        >
                            <thead className="text-center ">
                                <tr>
                                    <th
                                        colSpan={
                                            items.reports.data.headersFirstTable
                                                .length
                                        }
                                        className=""
                                    >
                                        DEMONSTRATIVO DO SALDO FINANCEIRO
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="">
                                {items.reports.data.sourcesFinancialBalances.map(
                                    (row, rowIndex) => (
                                        <tr
                                            key={rowIndex}
                                            style={
                                                rowIndex === 4
                                                    ? { fontWeight: 'bold' }
                                                    : {}
                                            }
                                        >
                                            {Object.keys(row).map(
                                                (item, keyIndex) => {
                                                    let currentValue =
                                                        keyIndex === 0
                                                            ? items.reports.data
                                                                  .sourcesFinancialBalances[
                                                                  rowIndex
                                                              ][item]
                                                            : formatCurrency(
                                                                  items.reports
                                                                      .data
                                                                      .sourcesFinancialBalances[
                                                                      rowIndex
                                                                  ][item]
                                                              );
                                                    let styleTd = '';
                                                    return (
                                                        <td
                                                            className={
                                                                'text-left '
                                                            }
                                                            style={{
                                                                ...styleTd
                                                            }}
                                                        >
                                                            {currentValue}
                                                        </td>
                                                    );
                                                }
                                            )}
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DirdFinancialBalance;
